import { CognitoUserPool } from "amazon-cognito-identity-js";

// devops-dashboard-users user ppol
const poolData = {
  UserPoolId: "ap-southeast-1_UcKk5XMKz",
  ClientId: "2fepqpv7e4kcp58bg335dq4jl5"
};

export default new CognitoUserPool(poolData);
